import React from 'react';
import classNames from 'classnames';
import {requireImage} from '../../../../utils/utils';
import {IOS_DEVICES} from '../../../../../states/dashboard/main/main.settings';
import {getRootStore} from '../../../../app.bootstrap';

export type MainTermsAndConditionsProps = {
    dir: 'ltr' | 'rtl';
    isAndroidOrIphone: 'android' | 'apple';
    isIE11: boolean;
    useNewInterface: boolean;
    rejectedTermsAndConditions: boolean;
    visible: boolean;
};

export const MainTermsAndConditions: React.FC<MainTermsAndConditionsProps> = ({
    dir,
    isAndroidOrIphone,
    isIE11,
    useNewInterface,
    rejectedTermsAndConditions,
    visible
}) => {
    const translate = getRootStore().localizationService.translate;

    if (!visible) {
        return null;
    }

    const deviceType = isAndroidOrIphone;
    const isAndroid = deviceType === IOS_DEVICES.ANDROID;

    const deviceImagePath = isAndroid ? 'wizard/android/terms-approval.png' : 'wizard/iphone/terms-approval.png';
    const deviceAltText = isAndroid ? 'android view' : 'iOS view';

    return (
        <div className='wizard-container' dir={dir}>
            <main className='ts-wizard-content'>
                <div className='steps-list'>
                    <div className='orange-text big-font'>{translate('WIZARD.MAIN.TAP_ALLOW')}</div>
                    <img
                        className={classNames('img-phone', 'img-T-C', {ie: isIE11})}
                        src={requireImage(deviceImagePath)}
                        alt={deviceAltText}
                    />
                    {rejectedTermsAndConditions && (
                        <div className={classNames({'reject-TOS-ie': isIE11})}>
                            <img
                                className={classNames('warning-img', {
                                    ie: isIE11,
                                    'not-ie': !isIE11
                                })}
                                src={requireImage('wizard/generic/attention_icon.png')}
                                alt='attention view'
                            />
                            <div
                                className={classNames('reject-terms-conditions', {
                                    'reject-terms-new-ui': useNewInterface,
                                    'not-ie': !isIE11
                                })}>
                                {translate('WIZARD.MAIN.REJECT_TERMS_AND_CONDITIONS')}
                            </div>
                        </div>
                    )}
                </div>
            </main>
        </div>
    );
};
